import { useLingui } from '@lingui/react/macro';

import { FiltersSubMenu } from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import { FilterRadioGroupWithLabel } from '@/design_system/Filters/FiltersMenu/FilterRadioGroupWithLabel';
import { RadioItem } from '@/design_system/Radio/RadioItem/RadioItem';
import IconFilters from '@/icons/Filters.svg';

import { useFilters } from '../FiltersState';
import { useSortByOptions } from '../utils';

export const FiltersSortBy = () => {
  const { t } = useLingui();

  const {
    sort: { sort, setSort },
    tab,
  } = useFilters();

  const options = useSortByOptions().map(({ id, label, ascLabel, descLabel }) => (
    <FilterRadioGroupWithLabel
      key={id}
      id={id}
      title={t({ id: 'requests.filters.sort.label', message: 'Sort by' })}
      label={label}
      value={sort[tab.tab].field === id ? sort[tab.tab].order : null}
      onChange={(order: 'asc' | 'desc') =>
        setSort({
          'to-do': { field: id, order },
          waiting: { field: id, order },
          all: { field: id, order },
        })
      }
    >
      <RadioItem value="asc" ariaLabel={label}>
        {ascLabel}
      </RadioItem>
      <RadioItem value="desc" ariaLabel={label}>
        {descLabel}
      </RadioItem>
    </FilterRadioGroupWithLabel>
  ));

  const selectedOption = useSortByOptions()?.find((option) => option.id === sort[tab.tab].field);

  return (
    <FiltersSubMenu
      id="sort-by"
      icon={<IconFilters />}
      label={`${t({ id: 'shipments.filters.sort.label', message: 'Sort by' })} (${selectedOption?.label} : ${selectedOption?.[sort[tab.tab].order === 'asc' ? 'ascLabel' : 'descLabel']})`}
      count={0}
    >
      {options}
    </FiltersSubMenu>
  );
};
